import { ChangeDetectionStrategy, Component, HostBinding, ViewEncapsulation } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    selector: 'mir-action-panel',
    templateUrl: './action-panel.component.html',
    styleUrls: ['./action-panel.component.scss'],
    standalone: false
})
export class MirActionPanelComponent {

  @HostBinding('class')
  get hostCssClass(): string {
    return `mir-action-panel
      action-panel
      w-full
      inline-flex
      justify-between
      items-center
      h-fit
      max-h-16`;
  }

}
